export const gitCommit = '2ff59b65'
